import { render } from "./RhAccordionGroup.vue?vue&type=template&id=341eeb37&scoped=true&ts=true"
import script from "./RhAccordionGroup.vue?vue&type=script&lang=ts"
export * from "./RhAccordionGroup.vue?vue&type=script&lang=ts"

import "./RhAccordionGroup.vue?vue&type=style&index=0&id=341eeb37&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341eeb37"]])

export default __exports__